import React, {useContext, useState} from 'react';
import { Route, Routes, useNavigate, Navigate } from "react-router-dom"

import { app } from '../config/fbConfig';
import {
    getFirestore, collection, onSnapshot,
    addDoc, deleteDoc, doc,
    query, where,
    orderBy, serverTimestamp,
    updateDoc,
    setDoc, Timestamp
  } from 'firebase/firestore'

import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword, signOut,
    onAuthStateChanged
  } from 'firebase/auth'

const auth = getAuth(app);

const db = getFirestore(app);  



export default function SignIn() {
    const navigate = useNavigate()
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    

    const handleLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
            .then((result) => {
                console.log(result)
            })
            .then(ref=>{
                setEmail("");
                setPassword("");
                navigate('/')
            })
            .catch((error) => {
                alert(error.message);
                console.log(error.message);
            })

    }

    if (auth.currentUser) return <Navigate replace to="/" />

    return (
        <div className="authContainer">
            <p>Welcome back to your azit!</p>
            <div className="formContainer">
                <form onSubmit={handleLogin}>
                    <input type="email" placeholder="Enter email..." value={email} onChange={(e)=>setEmail(e.target.value)} required/>
                    <input type="password" placeholder="Enter password..." value={password} onChange={(e)=>setPassword(e.target.value)} required/>
                    <input type="submit" value="Log in" />
                </form>
            </div>

            <div>No account yet?</div>
            <a href="/register">Create your Universe</a>
            <div className="stretch"></div>
        </div>
    )
}
